import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Button,
  CircularProgress,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

/**
 * PageBuilderTopBar
 *
 * Props:
 *  routePageId   {string|null}
 *  cloneFromId   {string|null}
 *  form          {object}
 *  effectiveId   {string|null}
 *  saving        {bool}
 *  onBack        {fn}
 *  onSaveDraft   {fn}
 *  onPublish     {fn}   — now opens confirm modal, not direct publish
 */
const PageBuilderTopBar = ({
  routePageId,
  cloneFromId,
  form,
  effectiveId,
  saving,
  onBack,
  onSaveDraft,
  onPublish,
}) => {
  const pageLabel = routePageId
    ? "Edit Page"
    : cloneFromId
    ? "Clone Page"
    : "New Page";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 3,
        py: 1.5,
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        position: "sticky",
        top: 0,
        zIndex: 10,
        backdropFilter: "blur(8px)",
        background: "rgba(255,255,255,0.02)",
      }}
    >
      {/* Left: back + title */}
      <Box display="flex" alignItems="center" gap={1.5}>
        <IconButton onClick={onBack} size="small">
          <ArrowBackIcon fontSize="small" />
        </IconButton>
        <Box>
          <Typography variant="subtitle2" fontWeight={600}>
            {pageLabel}
            {form.meta.title && ` — ${form.meta.title}`}
          </Typography>
          {form.meta.slug && (
            <Typography variant="caption" color="text.secondary">
              /{form.meta.slug}
            </Typography>
          )}
        </Box>
      </Box>

      {/* Right: saved status + actions */}
      <Box display="flex" gap={1.5} alignItems="center">
        {/* Saved indicator */}
        <Box display="flex" alignItems="center" gap={0.75}>
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: effectiveId ? "#4ade80" : "rgba(255,255,255,0.2)",
            }}
          />
          <Typography variant="caption" color="text.secondary" fontSize="11px">
            {effectiveId ? "Saved" : "Unsaved"}
          </Typography>
        </Box>

        {/* Save Draft */}
        {/* <Button
          variant="outlined"
          onClick={onSaveDraft}
          disabled={saving}
          startIcon={
            saving ? <CircularProgress size={12} color="inherit" /> : null
          }
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            fontSize: "12px",
            borderColor: "rgba(255,255,255,0.15)",
            color: "text.secondary",
            "&:hover": { borderColor: "#3b82f6", color: "#3b82f6" },
          }}
        >
          {saving ? "Saving..." : "Save Draft"}
        </Button> */}

        {/* Publish — opens confirm modal */}
        <Button
          variant="contained"
          onClick={onPublish}
          disabled={saving}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            fontSize: "12px",
            background: "#2e7d32",
            "&:hover": { background: "#1b5e20" },
          }}
        >
          Save & Publish
        </Button>
      </Box>
    </Box>
  );
};

export default PageBuilderTopBar;